import { type StickSide } from "@client/hocs/stickable";
import { ModalHeaderButton } from "@common/controls/Modal/Header/Buttons";
import { IconType } from "@common/declarations";
import * as React from "react";

export interface HeaderProps {
  addon?: React.JSX.Element;
  isFullScreen?: boolean;
  onBackClick?: () => void;
  onCloseClick?: () => void;
  onFullScreenClick?: () => void;
  onStickClick?: (e: MouseEvent | React.MouseEvent) => void;
  toStickSide?: StickSide | null;
  title?: any;

  children?: (props: HeaderRenderProps) => React.ReactNode;
}

export type HeaderRenderProps = {
  onCloseClick?: () => void;
};

const Header = (props: HeaderProps) => (
  <div className="modal-header">
    {props.children ? (
      props.children({ onCloseClick: props.onCloseClick })
    ) : (
      <>
        <h4 className="modal-title single-line-ellipsis">
          {props.onBackClick && (
            <ModalHeaderButton className="no_drag" icon={IconType.ArrowLeft} onClick={props.onBackClick} />
          )}

          <span className="title" dangerouslySetInnerHTML={{ __html: props.title }} />
        </h4>
        <div className="addon no_drag">{props.addon}</div>
        <div className="buttons">
          {!!props.onFullScreenClick && (
            <ModalHeaderButton
              className="pin no_drag"
              icon={props.isFullScreen ? IconType.ExitFullscreen : IconType.Fullscreen}
              onClick={props.onFullScreenClick}
            />
          )}
          {!!props.onStickClick && (
            <ModalHeaderButton
              className="no_drag"
              icon={props.toStickSide === "right" ? IconType.SidebarFlip : IconType.Sidebar}
              onClick={props.onStickClick}
            />
          )}

          {props.onCloseClick && (
            <ModalHeaderButton className="no_drag" icon={IconType.Cross} onClick={props.onCloseClick} />
          )}
        </div>
      </>
    )}
  </div>
);
export default Header;
